import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  mobileNavDrawer: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.agentTheme.card.main,
    height: "100vh",
    width: "100%",
    paddingTop: "5px",
    overflowY: "scroll",
    WebkitOverflowScrolling: "touch",
  },
  closeBtn: {
    marginRight: "40px",
  },
  usernameText: {
    color: theme.agentTheme.card.link_foreground,
    marginLeft: "8px",
  },
  contentTextSideNavbar: {
    fontWeight: 500,
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
    marginRight: "50px",
    cursor: "pointer",
    margin: theme.spacing(1, 0, 1, 1),
    display: "flex",
  },
  navbarContentContainer: {
    display: "flex",
    alignItems: "center",
    width: "60%",
    marginLeft: "16px",
    borderBottom: `0.5px solid ${theme.agentTheme.card.muted_foreground}`,
  },
  dropDownCard: {
    position: "absolute !important",
  },
  menuLogo: {
    height: "40.3px",
    width: "auto",
  },
  menuItemHeading: {
    fontWeight: "400 !important",
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
  },
  menuItemText: {
    fontWeight: "400 !important",
    fontSize: "16px",
    color: theme.agentTheme.card.link_foreground,
    marginTop: "14px",
    marginBottom: "26px",
    lineHeight: "20px",
  },
  mobilHelpDrawer: {
    marginTop: theme.spacing(3),
    backgroundColor: theme.agentTheme.card.main,
    height: "100%",
    width: "100%",
  },
  helpCloseBtn: {
    marginRight: "14px",
  },
  loginButton: {
    color: theme.agentTheme.card.link_foreground,
    backgroundColor: theme.agentTheme.card.main,
    height: "38px",
    width: "135px",
    [theme.breakpoints.down("sm")]: {
      height: "38px",
      width: "76px",
    },
  },
}));

export default useStyles;
